module.exports = __webpack_public_path__ + "media/images/sp/stores/funabashi/access/chiba-funabashi-point2-3@3x-3417bf3727dea7e0bdce70883afda5cf.webp";